export default "/_next/static/images/MyRoom-519d9e1d0861f97f200d9e8a2b0a0a47.png";